import React, { FC } from 'react';
import styled from 'styled-components';

interface Props {
	children: React.ReactNode;
}

const Container = styled.div<Props>`
	width: 100%;
`;

export const FullWidth: FC<Props> = props => {
	return <Container>{props.children}</Container>;
};
